export const DEFAULT_TURF_MAX_SIZE = 5;
export const MAX_TURF_MAX_SIZE = 25;

export const clampTurfMaxSize = (value: number, itemCount: number): number => {
  const maxSizeLimit = getTurfMaxSizeLimit(itemCount);

  if (!Number.isFinite(value)) return Math.min(DEFAULT_TURF_MAX_SIZE, maxSizeLimit);

  return Math.min(Math.max(Math.trunc(value), 1), maxSizeLimit);
};

export const getBooleanParam = (searchParams: URLSearchParams, key: string): boolean =>
  searchParams.get(key) === 'true';

export const getDelimitedParam = (searchParams: URLSearchParams, key: string): string[] =>
  searchParams
    .get(key)
    ?.split(',')
    .map((value) => value.trim())
    .filter(Boolean) ?? [];

export const getTurfMaxSize = (
  searchParams: URLSearchParams,
  key: string,
  itemCount: number
): number => clampTurfMaxSize(Number(searchParams.get(key) ?? DEFAULT_TURF_MAX_SIZE), itemCount);

export const getTurfMaxSizeLimit = (itemCount: number): number =>
  Math.max(1, Math.min(MAX_TURF_MAX_SIZE, itemCount || MAX_TURF_MAX_SIZE));

export const setBooleanParam = (params: URLSearchParams, key: string, value: boolean): void => {
  if (value) {
    params.set(key, 'true');
  } else {
    params.delete(key);
  }
};

export const setDelimitedParam = (
  params: URLSearchParams,
  key: string,
  values: string[] = []
): void => {
  const uniqueValues = Array.from(new Set(values.filter(Boolean)));

  if (uniqueValues.length) {
    params.set(key, uniqueValues.join(','));
  } else {
    params.delete(key);
  }
};
